import { useMemo } from 'react';
import { useField } from 'formik';

export default function useBulkEditExcludedIds({
  fieldName,
  showOnlySelected,
}) {
  const [{ value: items }] = useField(`request.${fieldName}`);

  return useMemo(() => {
    if (showOnlySelected !== false) {
      return undefined;
    }

    const ids = (items ?? [])
      .filter((item) => item.isSelected === true || item.isSelected === 'true')
      .map((item) => String(item.id))
      .sort();

    return ids.length > 0 ? ids : undefined;
  }, [showOnlySelected, items]);
}
